import script from "./SuccessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&setup=true&lang=js"

import "./SuccessDialog.vue?vue&type=style&index=0&id=1b7734ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7734ec"]])

export default __exports__